import styled from 'styled-components';
import { Link } from 'gatsby';

export const NavigationLinksContainer = styled.ul``;

export const NavigationLinkContainer = styled.li``;

export const NavigationLink = styled(Link)``;
